<div class="grid m-0 align-items-stretch">
    <div class="col-12">
        <h3 class="m-0 my-3 text-color">Safety Objectives</h3>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Objective Health'"
            [meta]="data.objectiveHealth.meta"
            [chartData]="data.objectiveHealth.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Objectives by Status'"
            [meta]="data.objectivesByStatus.meta"
            [chartData]="data.objectivesByStatus.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'line'"
            [title]="'Objectives Started Over Time'"
            [meta]="data.objectivesOverTime.meta"
            [chartData]="data.objectivesOverTime.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Target Date Outlook'"
            [meta]="data.targetDateOutlook.meta"
            [chartData]="data.targetDateOutlook.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'bars-horizontal'"
            [title]="'Objectives by Owner'"
            [meta]="data.objectivesByOwner.meta"
            [chartData]="data.objectivesByOwner.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12">
        <h3 class="m-0 my-3 text-color">Performance Indicators</h3>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Indicators by Data Source'"
            [meta]="data.indicatorsBySource.meta"
            [chartData]="data.indicatorsBySource.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Indicators by Measurement Interval'"
            [meta]="data.indicatorsByInterval.meta"
            [chartData]="data.indicatorsByInterval.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'bars-horizontal'"
            [title]="'Indicators per Objective'"
            [meta]="data.indicatorsPerObjective.meta"
            [chartData]="data.indicatorsPerObjective.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Targets by Type'"
            [meta]="data.targetsByType.meta"
            [chartData]="data.targetsByType.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12">
        <h3 class="m-0 my-3 text-color">Target Breaches</h3>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'line'"
            [title]="'Breaches Over Time'"
            [meta]="data.breachesOverTime.meta"
            [chartData]="data.breachesOverTime.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Breaches by Severity'"
            [meta]="data.breachesBySeverity.meta"
            [chartData]="data.breachesBySeverity.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Breaches by Status'"
            [meta]="data.breachesByStatus.meta"
            [chartData]="data.breachesByStatus.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'bars-horizontal'"
            [title]="'Most Breached Indicators'"
            [meta]="data.mostBreachedIndicators.meta"
            [chartData]="data.mostBreachedIndicators.chartData">
        </app-stat-chart>
    </div>
</div>
